<template>
  <div v-if="questions">
    <img
      v-if="questions[index].img"
      class="question-image"
      :src="getImgUrl(questions[index].img)"
    />
    <div class="question-area">
      <h3>Kysymys {{ index + 1 }}</h3>
      <p class="question">{{ questions[index].question }}</p>
      <explanation
        v-if="answers.length"
        :answers="answers"
        :correct="correct"
        :correctLength="questions[index].answers.length"
        :explanation="questions[index].explanation"
      />
      <div v-else class="options">
        <div :class="questions[index].type.includes('image') ? 'grid' : 'list'">
          <answer-option
            v-for="option in questions[index].options"
            :key="option.value"
            :option="option"
            :selected="selected.includes(option.value)"
            @select="setSelected"
          />
        </div>
      </div>
      <div class="button-area">
        <custom-button
          :text="answers.length ? 'Jatka' : 'Vastaa'"
          :disabled="!selected.length"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../config";
import AnswerOption from "./AnswerOption.vue";
import CustomButton from "./CustomButton.vue";
import Explanation from "./Explanation.vue";
export default {
  components: { AnswerOption, CustomButton, Explanation },
  data() {
    return {
      questions: Config.questions,
      index: 0,
      selected: [],
      correct: false,
      answers: [],
    };
  },
  methods: {
    getImgUrl(img) {
      return require("../assets/images/" + img);
    },
    setSelected(val) {
      if (this.questions[this.index].type.includes("one")) {
        this.selected = [val];
      } else {
        const index = this.selected.indexOf(val);
        if (index !== -1) {
          this.selected.splice(index, 1);
        } else {
          this.selected.push(val);
        }
      }
    },
    submit() {
      if (this.answers.length) {
        this.nextQuestion();
      } else {
        this.checkAnswers();
      }
    },
    checkAnswers() {
      const answered = this.selected;
      const correctAnswers = this.questions[this.index].answers;
      if (this.questions[this.index].type.includes("one")) {
        this.correct = correctAnswers.includes(answered[0]);
      } else {
        this.correct =
          answered.sort().toString() === correctAnswers.sort().toString();
      }

      this.answers = this.questions[this.index].options.flatMap((option) => {
        if (answered.includes(option.value)) {
          return {
            text: option.text,
            value: option.value,
            correct: correctAnswers.includes(option.value),
          };
        } else {
          return [];
        }
      });
    },
    nextQuestion() {
      if (this.correct) {
        this.$emit("pointIncrease");
      }
      if (this.index < this.questions.length - 1) {
        this.index++;
      } else {
        this.$emit("complete");
      }
      this.selected = [];
      this.correct = false;
      this.answers = [];
    },
  },
};
</script>

<style scoped>
.question-image {
  width: 100%;
  object-fit: contain;
}

.question-area {
  padding: 30px 40px;
}

.question {
  color: var(--quiz-text-color);
  margin: 25px 0;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, 1fr);
}

.button-area {
  text-align: center;
  margin-top: 25px;
}

@media only screen and (max-width: 600px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
